import { Link, useSearchParams } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import InlineSearch from "@/pages/catalog/components/InlineSearch";
import CatalogListing from "@/pages/catalog/components/CatalogListing";
import usePageMeta from "@/hooks/usePageMeta";

const hotKeywords = ["家庭伦理", "悬疑", "母亲", "沉默", "剧集", "香港"];

export default function SearchPage() {
  const [searchParams] = useSearchParams();
  const keyword = searchParams.get("q")?.trim() ?? "";

  usePageMeta(
    keyword ? `搜索：${keyword} - 伦理视频` : "全站搜索 - 伦理视频",
    keyword
      ? `伦理视频全站搜索「${keyword}」的结果，可按地区、年代、评分继续筛选相关伦理影视作品。`
      : "输入作品名称、导演、演员或类型关键词，快速查找伦理视频收录的伦理电影与伦理电视剧。",
    "影视搜索,伦理视频搜索,伦理电影查找,伦理剧集查找",
  );

  return (
    <SiteLayout>
      <PageHero
        eyebrow="Search"
        title="全站搜索"
        description="搜索范围包括作品中文名、外文名、导演、主演与类型标签。结果为前端演示数据，可在下方继续叠加筛选条件。"
        breadcrumbs={[{ label: "首页", to: "/" }, { label: "全站搜索" }]}
      >
        <InlineSearch key={keyword} initialValue={keyword} tone="dark" />
      </PageHero>

      <div className="w-full px-4 pt-8 md:px-10">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs text-foreground-500">热门搜索</span>
          {hotKeywords.map((item) => (
            <Link
              key={item}
              to={`/search?q=${encodeURIComponent(item)}`}
              className="whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:bg-secondary-200 hover:text-secondary-900 cursor-pointer"
            >
              {item}
            </Link>
          ))}
        </div>
      </div>

      <CatalogListing kind="all" searchQuery={keyword} />
    </SiteLayout>
  );
}